document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-blog')) return;

  var readButton = document.querySelector('[data-fj-journal-open]');
  var reader = document.querySelector('[data-fj-journal-reader]');
  var minimiseButtons = document.querySelectorAll('[data-fj-journal-close]');

  if (readButton) {
    readButton.style.fontSize = '1.05rem';
  }

  minimiseButtons.forEach(function (button) {
    button.style.fontSize = '1.05rem';
  });

  if (!readButton || !reader) return;

  readButton.addEventListener('click', function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (reader.hidden || readButton.getAttribute('aria-expanded') !== 'true') return;

        var header = document.querySelector('.section-header');
        var headerOffset = header ? header.offsetHeight : 0;
        var readerTop = reader.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({
          top: Math.max(0, readerTop),
          behavior: 'smooth'
        });
      });
    });
  });
});
